import { Icon, IIconProps } from '@fluentui/react/lib/Icon';

export interface IPIconProps extends IIconProps {}

export const IPIcon = (props: IPIconProps) => {
  return <Icon {...props} />;
};
